import { Button, styled } from "@mui/material";
import { brand } from "../../Theme/ColorsForTheam";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { useNavigate } from "react-router-dom";

const SoonComponentText = styled("p")`
  font-weight: 800;
  letter-spacing: -0.04em;
  color: ${brand.surface3};
  text-shadow: 0px 0px 10px rgba(28, 19, 9, 0.08);
`;
const BackButton = styled(Button)({
  padding: "8px 20px 8px 20px",
  marginLeft: "auto",
  marginRight: "auto",
  borderRadius: "8px",
});

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "calc(100vh - 270px)",
        }}
      >
        <SoonComponentText
          sx={{ fontSize: "228px", lineHeight: "250px", margin: 0 }}
        >
          404
        </SoonComponentText>
        <SoonComponentText
          sx={{ fontSize: "100px", lineHeight: "120px", margin: 0 }}
        >
          Page not found.
        </SoonComponentText>
        <BackButton
          sx={{ marginTop: "200px" }}
          variant="contained"
          onClick={() => {
            navigate("/");
          }}
          startIcon={<KeyboardBackspaceOutlinedIcon />}
        >
          Back to home
        </BackButton>
      </div>
    </div>
  );
};

export default NotFoundPage;
